"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearOrganizations = exports.BearOrganization = void 0;
var tslib_1 = require("tslib");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var securitySettings_1 = require("./securitySettings");
var BearOrganization = /** @class */ (function () {
    function BearOrganization(authCall, organizationId, organizationName) {
        this.authCall = authCall;
        this.organizationId = organizationId;
        this.organizationName = organizationName;
    }
    BearOrganization.prototype.getDescriptor = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accountInfo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if we already have the data, no reason to download them again
                        if (this.organizationName) {
                            return [2 /*return*/, {
                                    id: this.organizationId,
                                    title: this.organizationName,
                                }];
                        }
                        return [4 /*yield*/, this.authCall(function (sdk) { return sdk.user.getAccountInfo(); })];
                    case 1:
                        accountInfo = _a.sent();
                        return [2 /*return*/, {
                                id: this.organizationId,
                                title: accountInfo.organizationName,
                            }];
                }
            });
        });
    };
    BearOrganization.prototype.securitySettings = function () {
        var organizationUri = "/gdc/domains/" + this.organizationId;
        return new securitySettings_1.SecuritySettingsService(this.authCall, organizationUri);
    };
    return BearOrganization;
}());
exports.BearOrganization = BearOrganization;
var BearOrganizations = /** @class */ (function () {
    function BearOrganizations(authCall) {
        this.authCall = authCall;
    }
    BearOrganizations.prototype.getCurrentOrganization = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bootstrap, organizationId;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.authCall(function (sdk) { return sdk.user.getBootstrapResource(); })];
                    case 1:
                        bootstrap = _c.sent();
                        organizationId = this.getDomainIdFromDomainUri((_a = bootstrap.bootstrapResource.accountSetting.links) === null || _a === void 0 ? void 0 : _a.domain);
                        return [2 /*return*/, new BearOrganization(this.authCall, organizationId, (_b = bootstrap.bootstrapResource.settings) === null || _b === void 0 ? void 0 : _b.organizationName)];
                }
            });
        });
    };
    BearOrganizations.prototype.getDomainIdFromDomainUri = function (domainUri) {
        ts_invariant_1.default(domainUri, "Current user has no domain uri");
        var lastIndexOfSlash = domainUri.lastIndexOf("/");
        return domainUri.substr(lastIndexOfSlash + 1);
    };
    return BearOrganizations;
}());
exports.BearOrganizations = BearOrganizations;
//# sourceMappingURL=index.js.map